// ---------------------------------------------------------------------------
// MOTION TOKENS — the single source of truth for the site's animation language.
// Every preset and hook reads from here. Change a token, change the whole site.
// ---------------------------------------------------------------------------

// Durations (seconds — GSAP convention)
export const DUR = {
    fast: 0.18,   // micro-interactions: hovers, glows, small state changes
    button: 0.25, // premium button hover (spec window: 220–280ms)
    medium: 0.35, // standard transitions: lifts, magnetic snap-back
    slow: 0.7,    // entrances: reveals, fades, slides
    floatMin: 7,  // ambient floating loops
    floatMax: 12,
};

// Floating system — every value randomized per element, per axis
export const FLOAT = {
    ampMin: 4,      // px amplitude
    ampMax: 12,
    rotMin: 0.5,    // degrees
    rotMax: 2,
    scaleMin: 0.985,
    scaleMax: 1.015,
    durMin: 7,      // seconds
    durMax: 12,
    delayMax: 2,    // random start delay
};

// Easing — one curve everywhere. Registered as GSAP CustomEase "luxe"
// in MotionProvider. CSS string exported for any CSS-side transitions.
export const EASE = "luxe";
export const EASE_CSS = "cubic-bezier(0.22, 0.61, 0.36, 1)";
export const EASE_BEZIER = "0.22, 0.61, 0.36, 1";

// Distances / magnitudes (px unless noted)
export const DIST = {
    rise: 28,        // fade-up travel
    slide: 40,       // slide-reveal travel
    float: 12,       // ambient drift radius
    liftY: -6,       // hover lift height
    parallaxMouse: 18,   // max pointer-parallax offset
    parallaxScroll: 0.12,// scroll-parallax speed factor (fraction of scroll)
    magnetic: 0.35,      // magnetic pull strength (fraction of cursor delta)
    magneticRadius: 90,  // px activation radius around the element
};

// Effects
export const FX = {
    blur: 10,            // px — fade-blur starting blur
    scaleIn: 0.94,       // scale-in starting scale
    liftScale: 1.015,    // hover-lift scale
    glow: "0 0 24px rgba(198, 167, 107, 0.35)", // button glow (brand gold)
    glowStrong: "0 0 36px rgba(198, 167, 107, 0.5)",
};

// Stagger
export const STAGGER = {
    tight: 0.06,  // logo strips, small lists
    base: 0.1,    // card grids
    loose: 0.16,  // hero sequence steps
};
